export const glossary = [
  { term: "Invocação Especial", category: "Mecânica", definition: "Qualquer invocação que não seja a Invocação Normal/Baixar do turno." },
  { term: "Banir", category: "Ação", definition: "Remover a carta do jogo (fora do cemitério)." },
  { term: "Piercing", category: "Status", definition: "Dano de batalha infligido quando ataca um monstro em posição de defesa com ATK maior que a DEF." },
  { term: "Corrente (Chain)", category: "Mecânica", definition: "Sistema que determina a ordem de resolução de efeitos ativados em sequência." },
  { term: "Tributo", category: "Custo", definition: "Enviar um monstro do campo para o cemitério para realizar uma invocação de nível alto." }
];

export const faq = [];
